
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { EcommercePlatform } from '@/components/admin/campaigns/types';
import EcommercePlatformCard from './EcommercePlatformCard';

interface EcommercePlatformSelectorProps {
  onSelect: (platform: EcommercePlatform) => void;
}

const EcommercePlatformSelector: React.FC<EcommercePlatformSelectorProps> = ({
  onSelect,
}) => {
  const platforms: Array<{
    id: EcommercePlatform;
    title: string;
    description: string;
    icon: string;
  }> = [
    {
      id: 'shopify',
      title: 'Shopify',
      description: 'Connect your Shopify store to create referral campaigns with automatic reward distribution.',
      icon: '/lovable-uploads/shopify-icon.png', // You may need to upload this image
    },
    {
      id: 'woocommerce',
      title: 'WooCommerce',
      description: 'Integrate with your WordPress WooCommerce store for seamless referral tracking and rewards.',
      icon: '/lovable-uploads/woocommerce-icon.png',
    },
    {
      id: 'bigcommerce',
      title: 'BigCommerce',
      description: 'Connect your BigCommerce store to enable referral campaigns with automatic discount code generation.',
      icon: '/lovable-uploads/bigcommerce-icon.png',
    },
    {
      id: 'volusion',
      title: 'Volusion',
      description: 'Integrate with Volusion to add referral widgets and track e-commerce conversions.',
      icon: '/lovable-uploads/volusion-icon.png',
    },
    {
      id: 'wordpress',
      title: 'WordPress',
      description: 'Add referral capabilities to your WordPress site with our plugin integration.',
      icon: '/lovable-uploads/wordpress-icon.png',
    },
    {
      id: 'squarespace',
      title: 'Squarespace',
      description: 'Connect your Squarespace store to enable customer referrals and automatic rewards.',
      icon: '/lovable-uploads/squarespace-icon.png',
    },
    {
      id: 'magento',
      title: 'Magento',
      description: 'Integrate with Magento to create powerful e-commerce referral campaigns with advanced tracking.',
      icon: '/lovable-uploads/magento-icon.png',
    },
    {
      id: 'shift4shop',
      title: 'Shift4Shop',
      description: 'Connect your Shift4Shop store to enable referral widgets and automatic rewards.',
      icon: '/lovable-uploads/shift4shop-icon.png',
    }
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Select E-commerce Platform</CardTitle>
        <CardDescription>
          Choose your e-commerce platform to set up a referral campaign integration
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {platforms.map(platform => (
            <EcommercePlatformCard
              key={platform.id}
              platform={platform}
              onSelect={() => onSelect(platform.id)}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default EcommercePlatformSelector;
